import { z } from 'zod';
import { FleetRecoveryCanonicalJson,FleetRecoveryWireDecoder,fleetRecoveryCommandKeysSchema,fleetRecoveryIdSchema,fleetRecoverySha256Schema,fleetRecoverySignatureSchema } from '../fleetRecoverySchemas';
import type { IRecoverySignatureVerifierV3 } from './authority';

export const RECOVERY_REPAIR_BOOTSTRAP_DOMAIN = 'playcast-recovery-repair-bootstrap:v1\n';
export const recoveryRepairBootstrapDescriptorV1Schema = z.object({
  algorithm: z.literal('Ed25519'),keyId: fleetRecoveryIdSchema,signature: fleetRecoverySignatureSchema,
  payload: z.object({ schemaVersion: z.literal(1),kind: z.literal('immutable-recovery-repair'),
    sourceCommit: z.string().regex(/^[a-f0-9]{40}$/),runId: z.string().regex(/^[1-9]\d*$/),runAttempt: z.string().regex(/^[1-9]\d*$/),
    installerFileName: z.literal('Playcast-Recovery-Repair.exe'),installerSha256: fleetRecoverySha256Schema,
    installerBytes: z.string().regex(/^[1-9]\d*$/).refine(value => BigInt(value) <= 2n * 1024n * 1024n * 1024n),
    publisherId: fleetRecoverySha256Schema,bundleSha256: fleetRecoverySha256Schema,configurationSha256: fleetRecoverySha256Schema,
    cachePolicySha256: fleetRecoverySha256Schema,authorityConfigurationSha256: fleetRecoverySha256Schema,
    acceptedArgument: z.literal('/transition-id=<uuid>'),transitionDataEmbedded: z.literal(false),executesProduct: z.literal(false),
  }).strict(),
}).strict();
export type RecoveryRepairBootstrapDescriptorV1 = z.infer<typeof recoveryRepairBootstrapDescriptorV1Schema>;
export class RecoveryRepairBootstrapVerifierV1 {
  private readonly keys: Readonly<Record<string,string>>;
  public constructor(keys: Readonly<Record<string,string>>, private readonly crypto: IRecoverySignatureVerifierV3) {
    this.keys = fleetRecoveryCommandKeysSchema.parse(keys);
  }
  public verify(bytes: string): RecoveryRepairBootstrapDescriptorV1 {
    const envelope = FleetRecoveryWireDecoder.parse(bytes, recoveryRepairBootstrapDescriptorV1Schema, 16384);
    if (!Object.prototype.hasOwnProperty.call(this.keys, envelope.keyId)
      || !this.crypto.verify(this.keys[envelope.keyId], RECOVERY_REPAIR_BOOTSTRAP_DOMAIN
        + FleetRecoveryCanonicalJson.stringify(envelope.payload), envelope.signature)) {
      throw new Error('recovery_repair_bootstrap_untrusted');
    }
    return envelope;
  }
}
